// redux/reducer/userSlice.js
import { createSlice } from "@reduxjs/toolkit";

const userDetailsSlice = createSlice({
  name: "userDetails",
  initialState: {
    runClickTriger: {},
    userPlanDetails: {},
    userplan:"Free"
  },
  reducers: {
    setRunClick: (state, { payload }) => {
      state.runClickTriger = payload;
    },
    setUserPlanDetails: (state, { payload }) => {
      state.userPlanDetails = payload;
    },
    setUserPlan:(state,{payload})=>{
      state.userplan=payload
    }
  },
});

export const {setUserPlan, setUserPlanDetails, setRunClick } =
  userDetailsSlice.actions;
export default userDetailsSlice.reducer;
